const cleanLines = (block = "") =>
  String(block || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

const extractTitle = (lines) => {
  if (!lines.length) return "Assessment";
  const titleMatch = lines[0].match(/\*\*(.+?)\*\*/);
  return titleMatch ? titleMatch[1].trim() : lines[0];
};

const parseAssessmentBlock = (markdown = "") => {
  if (!markdown) return null;
  const lines = cleanLines(markdown);
  if (!lines.length) return null;

  const title = extractTitle(lines);
  const lowerLines = lines.map((line) => line.toLowerCase());
  const interpretationIndex = lowerLines.indexOf("interpretation");
  const whatIndex = lowerLines.indexOf("what this means");

  const metricsEnd =
    interpretationIndex !== -1
      ? interpretationIndex
      : whatIndex !== -1
      ? whatIndex
      : lines.length;

  const metrics = lines.slice(1, metricsEnd).filter(Boolean);

  const interpretation =
    interpretationIndex !== -1
      ? lines
          .slice(interpretationIndex + 1, whatIndex !== -1 ? whatIndex : lines.length)
          .join(" ")
          .trim()
      : "";

  const whatThisMeans =
    whatIndex !== -1 ? lines.slice(whatIndex + 1).join(" ").trim() : "";

  return {
    title,
    metrics,
    interpretation,
    whatThisMeans,
  };
};

export { parseAssessmentBlock };
